import apiClient from './apiClient';
import { isAuthenticated } from './auth';

export const getBrands = async (params = {}) => {
  try {
    const headers = {};
    
    // Construir parámetros de consulta
    const queryParams = new URLSearchParams();
    
    // Agregar filtro por nacional/internacional si se especifica
    if (params.is_national !== undefined) {
      queryParams.append('is_national', params.is_national);
    }
    
    const queryString = queryParams.toString();
    const url = queryString ? `/brands/?${queryString}` : '/brands/';
    
    const response = await apiClient.get(url, { headers });
    console.log('Brands response:', response.data);
    
    // Handle paginated response - extract results array
    let brandsData;
    if (response.data && response.data.results) {
      brandsData = response.data.results;
    } else if (Array.isArray(response.data)) {
      brandsData = response.data;
    } else {
      brandsData = [];
    }
    
    return brandsData.map(brand => ({
      ...brand,
      count: 0 // Se calculará en el componente
    }));
  } catch (error) {
    console.error('Error fetching brands:', error);
    return [];
  }
};

export const getNationalBrands = async () => {
  return getBrands({ is_national: true });
};

export const getInternationalBrands = async () => {
  return getBrands({ is_national: false });
};

export const getBrand = async (id) => {
  try {
    const headers = {};
    
    if (isAuthenticated()) {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    }
    
    const response = await apiClient.get(`/brands/${id}/`, { headers });
    return response.data;
  } catch (error) {
    console.error('Error fetching brand:', error);
    throw error;
  }
};

export const createBrand = async (brandData) => {
  try {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      throw new Error('No se encontró token de autenticación');
    }
    
    const response = await apiClient.post('/brands/', brandData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating brand:', error);
    throw new Error(error.response?.data?.message || 'Error al crear la marca');
  }
};

export const updateBrand = async (id, brandData) => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error('No se encontró token de autenticación');
  }
  
  const response = await apiClient.put(`/brands/${id}/`, brandData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  return response.data;
};

export const deleteBrand = async (id) => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error('No se encontró token de autenticación');
  }
  
  await apiClient.delete(`/brands/${id}/`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    }
  });
};
